<template>
  <header id="header" ref="header" role="banner">
    <div
      id="teleport-skip-links"
      class="absolute translate-x-[-150%] focus-within:translate-x-0 m-2 sm:m-4 bg-white shadow-xl z-[999] rounded-2xl [&>*:first-child]:rounded-t-2xl [&>*:last-child]:rounded-b-2xl"
    >
      <a class="flex p-2 sm:p-4" href="#contenuprincipal">Aller au contenu</a>
    </div>

    <HeaderBanner />
    <div id="teleport-header-top"></div>

    <div class="relative bg-white shadow-lg z-50">
      <HeaderMobile class="block lg:hidden" :full-width="fullWidth" />
      <HeaderDesktop class="hidden lg:block" :full-width="fullWidth" />
    </div>

    <ClientOnly>
      <Teleport to="#teleport-body-end">
        <TransitionGroup name="fade">
          <LazyMissionShareOverlay
            key="mission-share-overlay"
            v-if="$stores.missionShare.showOverlay"
          />
          <LazySoftGateOverlay key="soft-gate-overlay" v-if="$stores.softGate.showOverlay" />
          <LazyUserAlertOverlay key="user-alert-overlay" v-if="$stores.userAlert.showFormOverlay" />
          <LazyUserAlertMissionsOverlay
            key="user-alert-missions-overlay"
            v-if="$stores.userAlert.showMissionsOverlay"
          />
          <LazyArchivedUserOverlay
            key="archived-user-overlay"
            v-if="$stores.archivedUser.showOverlay"
          />
        </TransitionGroup>
      </Teleport>
    </ClientOnly>
  </header>
</template>

<script>
import HeaderBanner from '@/components/layout/HeaderBanner.vue'
import HeaderMobile from '@/components/section/header/HeaderMobile.vue'
import HeaderDesktop from '@/components/section/header/HeaderDesktop.vue'
import LazyUserAlertOverlay from '@/components/section/UserAlertOverlay.vue'
import LazySoftGateOverlay from '@/components/section/SoftGateOverlay.vue'
import LazyMissionShareOverlay from '@/components/section/MissionShareOverlay.vue'
import LazyArchivedUserOverlay from '@/components/section/ArchivedUserOverlay.vue'
import LazyUserAlertMissionsOverlay from '@/components/section/UserAlertMissionsOverlay.vue'

export default defineNuxtComponent({
  components: {
    HeaderBanner,
    HeaderMobile,
    HeaderDesktop,
    LazySoftGateOverlay,
    LazyUserAlertOverlay,
    LazyMissionShareOverlay,
    LazyArchivedUserOverlay,
    LazyUserAlertMissionsOverlay,
  },
  props: {
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
})
</script>
